import { render, staticRenderFns } from "./IdManagerSplitIdDetails.vue?vue&type=template&id=52e5bab4&scoped=true&"
import script from "./IdManagerSplitIdDetails.vue?vue&type=script&lang=js&"
export * from "./IdManagerSplitIdDetails.vue?vue&type=script&lang=js&"
import style0 from "./IdManagerSplitIdDetails.vue?vue&type=style&index=0&id=52e5bab4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e5bab4",
  null
  
)

export default component.exports